import React from "react";
import { Calendar, User as UserIcon, MapPin } from "lucide-react";
import OmfsCategoryChip from "@/components/OmfsCategoryChip";

const roleColor = {
  "Primary Surgeon": "chip-green",
  "First Assist": "chip",
  "Second Assist": "chip",
  "Teaching Assist": "chip",
  "Observer": "chip",
};

export default function MobileCaseCard({ c, onClick, onDelete }) {
  return (
    <div
      className="neu-card p-5 space-y-3 active:scale-[0.99] transition-transform"
      onClick={onClick}
      data-testid={`mobile-case-${c.id}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div className="heading text-lg leading-tight line-clamp-2">
            {c.procedure_name}
          </div>
          <div className="flex items-center gap-2 mt-1 flex-wrap">
            {c.procedure_category && (
              <span className="text-xs subtle">{c.procedure_category}</span>
            )}
            <OmfsCategoryChip
              category={c.omfs_procedure_category}
              size="xs"
              testId={`mobile-case-omfs-chip-${c.id}`}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 text-xs subtle">
        <span className="inline-flex items-center gap-1">
          <Calendar className="w-3 h-3" /> {c.date_of_procedure}
        </span>
        <span className="inline-flex items-center gap-1">
          <UserIcon className="w-3 h-3" /> {c.attending_physician}
        </span>
        <span className="inline-flex items-center gap-1">
          <MapPin className="w-3 h-3" /> {c.institution}
        </span>
      </div>
      <div className="flex items-center justify-between">
        <span className={`chip ${roleColor[c.role_in_case] || "chip"}`}>{c.role_in_case}</span>
      </div>
    </div>
  );
}